import { Env } from '../../env';
import { ApiClient } from '../../http/api_client';
import { SearchResultEnqueteJsEnv } from '../../models/search_result_enquete/search_result_enquete_js_env';

export class SearchResultEnqueteRepository {
  async sendResuqest(model: SearchResultEnqueteJsEnv) {
    const request = {
      llCategoryCode: model.llCategoryCode,
      lCategoryCode: model.lCategoryCode,
      mCategoryCode: model.mCategoryCode,
      sCategoryCode: model.sCategoryCode,
      searchKeyWord: model.searchKeyWord,
      isUseful: model.isUseful,
      userMessage: model.enqueteMessage,
      userTracking: model.userTracking,
      userId: model.userId,
      companyId: model.companyId,
      departmentId: model.departmentId,
      categoryType: model.categoryType
    };

    return ApiClient.postForAPIError(
      Env.SETTING.userPublicApi.urlBase + 'api/attract/search/searchResultEnquete?${ApiClient.showAlertWhile400Or500Error}',
      request
    );
  }
}
